import { PartitionOutlined } from '@ant-design/icons';

import MenuConfigType from '@app/types/MenuConfigType';

/**
 * Top-level Manual Routing tab (IFMDMS-62 / IFMDMS-66).
 * Hidden unless api/Features returns manualRouting === true.
 * TopMenu only renders items with privileged === true. Until the auth menu API returns
 * key `ManualRouting` (IFMDMS-70), privileged stays true so the tab can show when the flag is on.
 * When the backend does return that key, mapMenuConfig still marks it privileged from auth,
 * and the feature flag still hides it when manualRouting is off.
 */
const manualRoutingMenuConfig: MenuConfigType = {
  path: '/manual-routing/',
  title: 'Manual Routing',
  key: 'ManualRouting',
  icon: PartitionOutlined,
  guard: [],
  privileged: true,
  featureFlag: 'manualRouting',
};

export default manualRoutingMenuConfig;
